'use client';
import { cn } from '@baseball-near-you/ui';
import { useState } from 'react';

export function ReadMore({
  charCount = 200,
  ...props
}: {
  text: string;
  charCount?: number;
  className?: string;
  buttonLabels?: {
    showMore: string;
    showLess: string;
  };
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <p className={cn(props.className)}>
      {props.text.length <= charCount
        ? props.text
        : !expanded
          ? `${props.text.slice(0, charCount)}...`
          : props.text}
      {props.text.length > charCount && (
        <button
          type="button"
          onClick={(e) => {
            // e.stopPropagation();
            e.preventDefault();
            setExpanded(!expanded);
          }}
          className="ml-0.5 cursor-pointer whitespace-nowrap text-blue-500 hover:text-blue-700"
        >
          {expanded
            ? (props.buttonLabels?.showLess ?? 'show less')
            : (props.buttonLabels?.showMore ?? 'read more')}
        </button>
      )}
    </p>
  );
}
